import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import config from "../../../config/config";
import axios from "axios";
import { Link } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";

const RecevingPaymentSync = () => {
  const { IDsarray } = useContext(AppContext);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [transactions, settransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status , setstatus] = useState("")

  let Idstring =
    IDsarray && Array.isArray(IDsarray)
      ? IDsarray.map((item) => item.ID).join(",")
      : null;

  useEffect(() => {
    if (Idstring && token) {
      setLoading(true);
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/GetSalesQuickbookTransactionByIDs?IDS=${Idstring}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          settransactions(res.data.ResponseData);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } else {
      console.log("No IDs or token available.");
    }
  }, []);


  const handleclick = () => {
let reqobj = {
    data :transactions,
    ID:Id
}

    axios
    .post(
      `${config.salesconfigBaseUrl}/sales/SynctoQuickbook`,
      reqobj,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      }
    )
    .then((res) => {
console.log(res,"87878");

setstatus(res)

    })
    .catch((err) => {

    })
    
  }

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
        <div className="card">
        <div className="card-body">
            <div className="row"> 

            <button className="btn btn-primary col-2" onClick={handleclick}> Sync to Quickbook </button>
            <p className="col-md-6 mt-3 p-medium"> {status?.status == 201 ? "Quickbook Synced" : "Quickbook Failed"} </p>
            </div>
            </div>
            </div>
          

          <div className="card">
            <div className="card-body">
              <h2 className="card-title">Transaction Table</h2>
              {transactions.length > 0 ? (
                transactions.map((transaction) => {
                  const reqObj = JSON.parse(transaction.Req_Obj);

                  return (
                    <div key={transaction.ID} className="mb-4">
                      <h4>Transaction ID: {transaction.Txn_QB_ID}</h4>
                      <p>
                        Created Date:{" "}
                        {new Date(transaction.CreatedDate).toLocaleString()}
                      </p>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>TxnId</th>
                            <th>TxnType</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reqObj.Line.map((lineItem, lineIndex) => (
                            <tr key={`${transaction.ID}-${lineIndex}`}>
                              <td>{lineItem.Amount}</td>
                              <td>{lineItem.LinkedTxn[0].TxnId}</td>
                              <td>{lineItem.LinkedTxn[0].TxnType}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })
              ) : (
                <p>No transactions available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecevingPaymentSync;
